import { ExperimentProvider as CarvanaExperimentProvider } from '@carvana/experiment';
import React from 'react';
import { settings } from '~/constants/common/experiments';
import { Experiments } from '~/contracts/common';
import useExperimentsWithIdentifiers from '~/hooks/common/useExperimentsWithIdentifiers';
import BrowserCookies from '~/utilities/BrowserCookies';

export type PropsFromServer = {
  browserCookieId: string;
  experiments: Partial<Experiments>;
  serverCookies: Record<string, string>;
  userId: string;
};

type OwnProps = React.PropsWithChildren<
  PropsFromServer & {
    browserCookieIdExperiments: Partial<Experiments>;
    userIdExperiments: Partial<Experiments>;
  }
>;

export default function ExperimentProvider(props: OwnProps) {
  const experimentsWithIdentifiers = useExperimentsWithIdentifiers({
    browserCookieId:
      props.browserCookieId || BrowserCookies.get('BrowserCookieId') || '',
    browserCookieIdExperiments: props.browserCookieIdExperiments,
    userId: props.userId,
    userIdExperiments: props.userIdExperiments
  });

  return (
    <CarvanaExperimentProvider
      defaults={settings}
      onPageLoadExperiments={experimentsWithIdentifiers}
      preloadedExperiments={props.experiments}
      serverCookies={props.serverCookies}
    >
      {props.children}
    </CarvanaExperimentProvider>
  );
}
